var $66872748287c2613$exports = {};
$66872748287c2613$exports = {
    "endTime": `\u{7D42}\u{4E86}\u{6642}\u{523B}`,
    "startTime": `\u{958B}\u{59CB}\u{6642}\u{523B}`,
    "time": `\u{6642}\u{523B}`
};


export {$66872748287c2613$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
